import { useCallback, useEffect, useState } from 'react';

import { AutoComplete, AutoCompleteProps } from 'primereact/autocomplete';

import { useLazySearchDrugsQuery } from '@/app/services/lookups';
import { MIN_SEARCH_LENGTH, SELECTION_LIMIT } from '@/constants';
import { Drug } from '@/rtk-query.gql';

import './DrugsAutoComplete.css';

type DrugsAutoCompleteProps = AutoCompleteProps & {
  className?: string;
  label?: string;
  defaultValue?: Drug;
  forceNewSuggestionsRef?: boolean;
};

export const DrugsAutoComplete = ({
  className,
  label,
  defaultValue,
  forceNewSuggestionsRef = false,
  ...autoCompleteProps
}: DrugsAutoCompleteProps) => {
  const [selected, setSelected] = useState<Drug | undefined>(defaultValue);
  const [filtered, setFiltered] = useState<Drug[]>([]);
  const [inputValue, setInputValue] = useState(defaultValue);

  useEffect(() => {
    setSelected(defaultValue);
    setInputValue(
      typeof defaultValue === 'string'
        ? defaultValue
        : (defaultValue?.name ?? undefined),
    );
  }, [defaultValue]);

  const [query] = useLazySearchDrugsQuery();

  const search = useCallback(
    async (event: { query: string }) => {
      const { data = [] } = await query({
        search: event.query || '',
        selectionLimit: SELECTION_LIMIT,
      });

      setFiltered(forceNewSuggestionsRef ? [...data] : data);
    },
    [forceNewSuggestionsRef, query],
  );

  const handleSelect = (e: { value: Semen }) => {
    setSelected(e.value);
    if (setInputValue) {
      setInputValue(e.value?.name as string);
    }
  };

  const handleChange = (e: { value: string }) => {
    if (setInputValue) {
      setInputValue(e.value as string);
    }
  };

  return (
    <div
      className={`[ drugs-auto-complete ] [${className ? ` ${className}` : ''} label-input-group ]`}
    >
      {label && <label>{label}</label>}
      <AutoComplete
        appendTo="self"
        suggestions={filtered}
        minLength={MIN_SEARCH_LENGTH}
        selectionLimit={SELECTION_LIMIT}
        completeMethod={search}
        onSelect={handleSelect}
        onChange={handleChange}
        dropdown={true}
        {...autoCompleteProps}
        value={inputValue}
      />
    </div>
  );
};
